// ====================================================================================
// flyoutSearch.module
// ====================================================================================
import $ from "jquery";

const $body = $("body");
const $searchToggler = $(".search-toggle");
// const $search = $("#search");

export const init = () => {
  $searchToggler.on("click", function (e) {
    e.preventDefault();
    $body.toggleClass("search-open");
    //close menu when search is open
    if ($body.hasClass("menu-open")) {
      $body.removeClass("menu-open");
      $("#mainmenu").slideUp();
    }
    e.stopPropagation();
  });

  document.addEventListener("click", (e) => {
    if ($body.hasClass("search-open") && e.target.closest("#search") == null) {
      $searchToggler.click();
    }
  });

  let attempts = 0;
  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      // --- code ---
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };
  whenComplete();
};
